import React, { FC } from 'react';
import { IBookCurriculumGoal } from '../../../../../config/api/models/CurriculumGoal';
import { IconButton, Icons, Tooltip } from '../../../../shared/components';
import { useUser } from '../../../../shared';
import { Theme, styled } from '@material-ui/core';

type Props = {
  addedGoals: IBookCurriculumGoal[];
  onDeleteGoal: (goal: IBookCurriculumGoal) => void;
};

const Wrapper = styled('div')<Theme>(({ theme }) => ({
  padding: theme.spacing(1, 0, 0, 0),
}));

const Goal = styled('div')<Theme>(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'start',
  padding: '0.5rem 2rem 0.5rem 0.5rem',
  '&:not(:last-child)': {
    borderBottom: theme.config.defaultBorder(theme.palette.grey['100']),
  },
}));

const GoalId = styled('div')<Theme>(({ theme }) => ({
  color: theme.palette.primary.main,
  marginRight: theme.spacing(1),
}));

const GoalBrick = styled('div')<Theme>(({ theme }) => ({
  marginRight: theme.spacing(1),
}));

const DeleteButton = styled(IconButton)({
  position: 'absolute',
  right: 0,
  top: '50%',
  transform: 'translateY(-50%)',
});

const TrajectoryCurriculumGoalsList: FC<Props> = ({ addedGoals, onDeleteGoal }) => {
  const { isStudent, isAuthor } = useUser();

  return (
    <Wrapper>
      {addedGoals.map((goal: IBookCurriculumGoal, index: number) => (
        <Goal key={index}>
          <GoalId>{goal.goalId}</GoalId>
          <Tooltip title={goal.brick} placement="left">
            <GoalBrick>{isStudent ? goal.studentDescription : goal.endTerm}</GoalBrick>
          </Tooltip>
          {isAuthor && (
            <DeleteButton small icon={Icons.DELETE} onClick={() => onDeleteGoal(goal)} />
          )}
        </Goal>
      ))}
    </Wrapper>
  );
};

export default TrajectoryCurriculumGoalsList;
